import { useCallback, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import { deleteDevice } from 'modules/devices/store/actions';
import { toast } from 'react-toastify';

export function useDeleteDevice(refetch: () => void) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (id: number) => {
      setIsLoading(true);
      try {
        await dispatch(deleteDevice(id)).unwrap();
        toast.success('Устройство удалено');
        refetch();
      } catch {
        toast.error('Не удалось удалить устройство');
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, refetch],
  );

  return { mutate, isLoading };
}
